import axios, { AxiosError } from 'axios';
import { IError } from '../interfaces/IError';
import { ErrorResponseBody } from './generated/orderManage';

/**
 * APIからのエラーを処理する
 * @param error - エラーオブジェクト
 * @param data - エラー時に返すデータ
 */
export const axiosErrorHandler = <T = unknown>(error: unknown, data?: T): IError<T> => {
  if (axios.isAxiosError(error) && error.response && error.response.data) {
    // ここで err は AxiosError として扱われる
    const errorResponse = error.response.data as unknown as ErrorResponseBody;
    const errorObj: IError<T> = {
      statusCode: errorResponse.statusCode,
      code: errorResponse.code,
      message: errorResponse.message,
      data,
    };
    return errorObj;
  } else {
    // err が AxiosError ではない場合の処理
    const errorObj: IError<T> = {
      statusCode: 500,
      code: 'unknown',
      message: 'An unexpected error occurred',
      data,
    };
    return errorObj;
  }
};
